require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./videos-coverr-video-of-meeting-room.json") })
        }
      }, "path---videos-coverr-video-of-meeting-room");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---videos-coverr-video-of-meeting-room!./.cache/json/videos-coverr-video-of-meeting-room.json
// module id = 951
// module chunks = 231608221292675